import React from 'react'
import './Partners.scss';
import InfoImage from '../../../Assets/Images/info.svg';
import InfoFirstImage from '../../../Assets/Images/info1.svg';
import InfoSecImage from '../../../Assets/Images/info2.svg';
import InfoThreeImage from '../../../Assets/Images/info3.svg';
import InfoFourImage from '../../../Assets/Images/info4.svg';
import InfoFiveImage from '../../../Assets/Images/info5.svg';
export default function Partners() {
    return (
        <>
           <section className="insurance-info">
                <div className="new-container">
                    <div className="title-text">
                        <h2>Everything an enterprise needs on a platform:</h2>
                    </div>
                    <div className="grid">
                        <div className="grid-items">
                            <div className="icon-center">
                                <img src={InfoImage} alt="InfoImage"/>
                            </div>
                            <h3>Agile</h3>
                            <p>
                                Rapidly build, train and reconfigure neural networks for faster time-to-deploy
                            </p>
                        </div>
                        <div className="grid-items">
                            <div className="icon-center">
                                <img src={InfoFirstImage} alt="InfoFirstImage"/>
                            </div>
                            <h3>Reliable</h3>
                            <p>
                               Monitor deployments and performance. Use metrics to make decisions on scale and architecture.
                            </p>
                        </div>
                        <div className="grid-items">
                            <div className="icon-center">
                                <img src={InfoSecImage} alt="InfoSecImage"/>
                            </div>
                            <h3>Flexible</h3>
                            <p>
                              Cloud or private data centers – deploy and build complex solutions as per needs.
                            </p>
                        </div>
                        <div className="grid-items">
                            <div className="icon-center">
                                <img src={InfoThreeImage} alt="InfoThreeImage"/>
                            </div>
                            <h3>Collaboration</h3>
                            <p>
                              Enable collaborative modelling among multiple team members.
                            </p>
                        </div>
                        <div className="grid-items">
                            <div className="icon-center">
                                <img src={InfoFourImage} alt="InfoFourImage"/>
                            </div>
                            <h3>Control</h3>
                            <p>
                                Monitor enterprise wide WIP development activities and deployments through an advanced dashboard.
                            </p>
                        </div>
                        <div className="grid-items">
                            <div className="icon-center">
                                <img src={InfoFiveImage} alt="InfoFiveImage"/>
                            </div>
                            <h3>Multi-Function</h3>
                            <p>
                               Structured or unstructured or hybrid datasets? VEGA works with any type of dataset!
                            </p>
                        </div>
                    </div>
                </div>
           </section>
        </>
    )
}
